import { render, staticRenderFns } from "./DisplayGroups.vue?vue&type=template&id=aaf47276&scoped=true"
import script from "./DisplayGroups.vue?vue&type=script&lang=js"
export * from "./DisplayGroups.vue?vue&type=script&lang=js"
import style0 from "./DisplayGroups.vue?vue&type=style&index=0&id=aaf47276&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf47276",
  null
  
)

export default component.exports